import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useI18n } from "../i18n";
import { Navbar } from "../components/Navbar";
import { SmoothScroll } from "../components/SmoothScroll";
import { Hero } from "../components/Hero";
import { AnnouncementBanner } from "../components/AnnouncementBanner";
import { Stats } from "../components/Stats";
import { Programme } from "../components/Programme";
import { Biography } from "../components/Biography";
import { SupportSection } from "../components/SupportSection";
import { AdhesionSection } from "../components/AdhesionSection";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";
import { InstallButton } from "../components/InstallButton";
import { MusicPlayer } from "../components/MusicPlayer";

const HomePage = () => {
  const { t } = useI18n();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const params = new URLSearchParams(window.location.search);
    const don = params.get("adhesion");
    const sessionId = params.get("session_id");
    const clean = () => window.history.replaceState({}, "", window.location.pathname);

    if (don === "cancel") {
      toast.info(t("pay.cancel"));
      clean();
      return;
    }
    if (don === "success" && sessionId) {
      let attempts = 0;
      const poll = async () => {
        attempts += 1;
        try {
          const { data } = await api.get(`/adhesion/status/${sessionId}`);
          if (data.payment_status === "paid") {
            toast.success(t("pay.success"), { duration: 6000 });
            clean();
            return;
          }
          if (data.status === "expired") {
            toast.error(t("pay.expired"));
            clean();
            return;
          }
        } catch (_) {}
        if (attempts < 6) setTimeout(poll, 2000);
        else { toast.info(t("pay.verify")); clean(); }
      };
      toast.loading(t("pay.checking"), { duration: 2000 });
      poll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);

  return (
    <>
      <SmoothScroll />
      <Navbar />
      <main>
        <Hero />
        <AnnouncementBanner />
        <Stats />
        <Programme />
        <Biography />
        <SupportSection />
        <AdhesionSection />
        <ContactSection />
      </main>
      <Footer />
      <InstallButton />
      <MusicPlayer />
    </>
  );
};

export default HomePage;
